import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CityDTO} from '../dto/city.model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  citySearchDetailsChange = new EventEmitter<CityDTO[]>();
  private citySearchDetailsItem: CityDTO[] = [];

  private headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8'
  });

  public BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  /**Save City Details **/
  saveCityDetails(cityDTO: CityDTO) {
    return this.httpClient.post(this.BASE_URL + 'city/save' , cityDTO,{responseType: 'text'});
  }

  /** Get all city details **/
  getAllCityDetails(){
    return this.httpClient.get(this.BASE_URL + 'city/all');
  }

  /** Search City Details **/
  searchCity(cityDTO: CityDTO){
    return this.httpClient.post(this.BASE_URL + 'city/search', cityDTO, { headers: this.headers });
  }

  /** Delete city details **/
  deleteCityDetails(code: string){
    return this.httpClient.delete(this.BASE_URL + 'city/delete/'+code, { headers: this.headers });
  }


  /** reset searched details **/
  clearCitySearchDetails() {
    this.citySearchDetailsItem = [];
    this.citySearchDetailsChange.emit(this.citySearchDetailsItem);
  }

  /** set search details in the table **/
  setCitySearchDetails(cityDetails: CityDTO[]) {
    this.citySearchDetailsItem = cityDetails;
    this.citySearchDetailsChange.emit(this.citySearchDetailsItem);
  }
}
